/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
import React, { useState, useContext, useEffect } from 'react';
import { cloneDeep } from 'lodash-es';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { NestedMenuItem, ActionIcon } from '@mummssoftware/common-ui';
import { PalliativeCare } from '@mummssoftware/utils/constants';
import { shouldDisableHcpcsMenu } from '@mummssoftware/utils/hcpcsValidationUtils';
import { Context } from '../../context';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import { VisitContext } from '../Context/contexts/VisitContext';
import {
  SET_HCPCS_CHOICE,
  DISABLE_HCPCS_MENU,
  RECORD_DATA,
} from '../Context/constants';
import { useStyles } from './style';
import { iconStyle, ACP, PSY } from './constants';
import { MenuDiv } from '../../components/layout/HCPCSWrapper';

export const HCPCSMenu = () => {
  const { savedVisit } = useContext(VisitContext);
  const hcpcsMenu: any = window.env?.hcpcs || null;
  const keyRole = savedVisit?.careProviderRoleGroup
    .toLowerCase()
    // remove white space
    .replace(/\s/g, '');

  const selectedMenu = hcpcsMenu && keyRole ? hcpcsMenu[keyRole] : [];
  const {
    dispatchHCPCS,
    hcpcsMapping,
    disabledHCPCSMenu,
    hcpcsDuration,
    icdCodeNames,
    icdSection,
    showVisitLoader,
  } = useContext(HCPCSContext);
  const { patient } = useContext(Context);
  const isPalCarePatient = patient?.programSiteName === PalliativeCare;

  const [hcpcsPhysMenu, setHCPCSPhysMenu] = useState<any>(selectedMenu);

  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const menuDisabled = disabledHCPCSMenu || showVisitLoader;

  useEffect(() => {
    if (showVisitLoader) {
      closeMenu();
    }
  }, [showVisitLoader]);

  const openMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const setMenuItem = (item: any) => {
    setAnchorEl(null);
    dispatchHCPCS({
      type: RECORD_DATA,
      payload: true,
    });
    dispatchHCPCS({
      type: SET_HCPCS_CHOICE,
      payload: item,
    });
  };

  const getACPMenu = (hcpcsKeys: any, menu: any) => {
    let updatedMenu = [...menu];
    hcpcsKeys.forEach((key: string) => {
      updatedMenu = updatedMenu.filter(
        (x: any) => x.key !== key && !x.key.includes(PSY),
      );
      // @note in case this changes one more time
      // updatedMenu = updatedMenu.map((x: any) => {
      //   if (x.key === key) {
      //     return { ...x, disabled: true };
      //   }
      //   if (x.key.includes(PSY)) {
      //     return { ...x, disabled: true };
      //   }
      //   if (key.includes(x.key)) {
      //     const newMenu = [...x.submenu].map((i: any) => ({
      //       ...i,
      //       disabled: true,
      //     }));
      //     x.submenu = newMenu;
      //   }
      //   return x;
      // });
    });
    return updatedMenu;
  };

  const getServicedMenu = (hcpcsKeys: any, menu: any) => {
    let updatedMenu = [...menu];
    hcpcsKeys.forEach((key: string) => {
      updatedMenu = updatedMenu.filter((x: any) => x.key === ACP);
    });
    return updatedMenu;
  };

  const getUpdatedMenuBeg = (hcpcsKeys: any, menu: any) => {
    // step 1 : select ACP first - can still select services
    if (hcpcsKeys && hcpcsKeys.length === 1 && hcpcsKeys.includes(ACP)) {
      const updatedMenu = getACPMenu(hcpcsKeys, menu);
      return updatedMenu;
      // step 2 : psychotherapy - can only be selected by itself
    } else if (
      hcpcsKeys &&
      hcpcsKeys.length === 1 &&
      hcpcsKeys[0].includes(PSY)
    ) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: true,
      });
      // step 3: services - can be selected with ACP
    } else if (
      hcpcsKeys &&
      hcpcsKeys.length === 1 &&
      // services
      hcpcsKeys[0].includes('S')
    ) {
      const updatedMenu = getServicedMenu(hcpcsKeys, menu);
      return updatedMenu;
    }
    dispatchHCPCS({
      type: DISABLE_HCPCS_MENU,
      payload: true,
    });
    return [];
  };

  /**
   * Disable the menu if duration or icd not ok
   */

  useEffect(() => {
    dispatchHCPCS({
      type: DISABLE_HCPCS_MENU,
      payload: shouldDisableHcpcsMenu({
        hcpcsMapping,
        hcpcsDuration,
        icdCodeNames,
        icdSection,
        isPalCarePatient,
      }),
    });
  }, [
    hcpcsMapping && Object.keys(hcpcsMapping).toString(),
    icdCodeNames && Object.values(icdCodeNames).toString(),
    hcpcsDuration && Object.values(hcpcsDuration).toString(),
    JSON.stringify(icdSection),
    isPalCarePatient,
    dispatchHCPCS,
  ]);

  useEffect(() => {
    if (hcpcsMapping && Object.keys(hcpcsMapping).length) {
      const hcpcsKeys = Object.keys(hcpcsMapping);
      const menu = cloneDeep(selectedMenu);
      const updatedMenu = getUpdatedMenuBeg(hcpcsKeys, menu);
      setHCPCSPhysMenu(updatedMenu);
    } else {
      setHCPCSPhysMenu(selectedMenu);
    }
    // toString to avoid many re-renders
  }, [hcpcsMapping && Object.keys(hcpcsMapping).toString()]);

  const createMenu = (menuItems?: mumms.HCPCSCascadeMenu | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: mumms.HCPCSCascadeMenuItem, i: number) => (
          <MenuItem
            key={`choice-${i}`}
            disabled={choice.disabled}
            onClick={() => setMenuItem(choice)}
          >
            <MenuDiv color={choice.color}>{choice.name}</MenuDiv>
          </MenuItem>
        ))}
      </div>
    ) : (
      <div></div>
    );

  const createCascadeMenu = (menuItems?: mumms.HCPCSCascadeMenu | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: mumms.HCPCSCascadeMenuItem, i: number) =>
          choice.submenu ? (
            <NestedMenuItem
              label={choice.name}
              key={`choice-${i}`}
              parentMenuOpen={Boolean(anchorEl)}
              disabled={choice.disabled}
            >
              {createMenu(choice.submenu)}
            </NestedMenuItem>
          ) : (
            <MenuItem
              key={`choice-${i}`}
              onClick={() => setMenuItem(choice)}
              disabled={choice.disabled}
            >
              <MenuDiv color={choice.color}>{choice.name}</MenuDiv>
            </MenuItem>
          ),
        )}
      </div>
    ) : (
      <div></div>
    );

  return (
    <>
      <ActionIcon
        style={iconStyle}
        Icon={AddCircleIcon}
        onClick={openMenu}
        disabled={menuDisabled}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && !showVisitLoader}
        onClose={closeMenu}
        PaperProps={{
          classes: {
            elevation8: classes.introMenu,
          },
        }}
      >
        <div>{createCascadeMenu(hcpcsPhysMenu)}</div>
      </Menu>
    </>
  );
};
